import React, { useEffect, useState } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import axios from 'axios';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const BootcampAccept = () => {
  const query = useQuery();
  const history = useHistory();
  const docId = query.get('docId');
  const userEmail = query.get('userEmail');
  const token = query.get('token');
  const action = query.get('action') || 'accept';
  const [status, setStatus] = useState('pending');
  const [message, setMessage] = useState('Processing...');

  useEffect(() => {
    if (!docId || !token) {
      setStatus('error');
      setMessage('Missing docId or token in the link.');
      return;
    }

    const accept = async () => {
      try {
        // POST to backend to accept the subscription
        const res = await axios.post('/acceptBootcampSubscription', { docId, userEmail, token, action });
        if (res && res.data && res.data.ok) {
          setStatus('success');
          setMessage(action === 'accept' ? 'Subscription accepted. Thank you!' : 'Subscription declined. Thank you for your response.');
          // Optionally redirect to profile or login after a few seconds
          setTimeout(() => history.push('/client/profile'), 3000);
        } else {
          setStatus('error');
          setMessage((res && res.data && res.data.error) || 'Unknown response from server');
        }
      } catch (err) {
        const text = err?.response?.data?.error || err.message || 'Network error';
        setStatus('error');
        setMessage(text);
      }
    };

    accept();
  }, [docId, token, history]);

  return (
    <div style={{ padding: 40 }}>
      <h2>Bootcamp Subscription</h2>
      {status === 'pending' && <p>{message}</p>}
      {status === 'success' && <div style={{ color: 'green' }}>{message}</div>}
      {status === 'error' && <div style={{ color: 'red' }}>{message}</div>}
    </div>
  );
};

export default BootcampAccept;
